// extracted by mini-css-extract-plugin
module.exports = {"Thumbnails":"ImageGallery_Thumbnails___eikb","ImageGalleryWithPagination":"ImageGallery_ImageGalleryWithPagination__Yu_xM"};